import { getLogRequestHeaderValue } from './required';
import { useJwtStore } from '@/stores/jwt';

const lastRefreshTokenDate = ref<string>('');

function isValidLastRefreshToken(): boolean {
  if (!lastRefreshTokenDate.value) {
    updateLastRefreshTokenDate();

    return false;
  }

  const lastRefreshTokenInMs = +new Date(lastRefreshTokenDate.value);
  const currentDateInMs = +new Date();
  const A_HOUR_IN_MS: number = 1000 * 60 * 60 * 6;

  const diffs = currentDateInMs - lastRefreshTokenInMs;
  const isRefreshTokenOlderThanOneHour = diffs > A_HOUR_IN_MS;

  if (isRefreshTokenOlderThanOneHour) {
    updateLastRefreshTokenDate();
  }

  return isRefreshTokenOlderThanOneHour;
}

export function updateLastRefreshTokenDate() {
  lastRefreshTokenDate.value = new Date().toString();
}

export function handleRefreshToken(token: string) {
  if (!token) {
    throw new Error('jwt: no token specified');
  }

  if (window.__crtc__) {
    return;
  }

  window.__crtc__ = true; // cactus refresh token check

  if (!isValidLastRefreshToken()) {
    return;
  }

  setTimeout(async function () {
    const response = await fetch('/api/users/refresh-token', {
      headers: {
        authorization: 'Bearer ' + token,
        'X-LOG-INFO': getLogRequestHeaderValue(),
      },
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
    });

    const data = await response.json();

    if (data.access_token) {
      updateLastRefreshTokenDate();

      try {
        const jwtStore = useJwtStore();

        jwtStore.saveToken(data.access_token);
      } catch (ex) {
        console.error('Critical files modified:');
        console.error(ex);
      }
    }
  }, 0);
}
